export default __webpack_public_path__ + "static/media/Mark-4-HUD-Altimeter.a909d57a.jpg";